import { useRef } from 'react';

/**
 * Holds the latest value in a ref so callbacks (e.g. data loaders) can read fresh
 * data without listing that value in useCallback deps — avoids refetch loops when
 * derived objects (like column filter defs) get new references every fetch.
 */
export function useLatest(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
